import { defineMessages } from 'react-intl';

import { FILTERS } from '@sorare/core/src/lib/filters';
import { glossary } from '@sorare/core/src/lib/glossary';

import { RefineListProps } from 'search/RefineList';
import { makeFilter } from 'searchCards/RefineList';

const optionsForActiveFilters = defineMessages({
  eth: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.eth',
    defaultMessage: 'ETH accepted',
  },
  cash: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.cash',
    defaultMessage: 'Cash accepted',
  },
});

export const getFormatSettlementWallets: (
  forActiveFilters: boolean
) => NonNullable<RefineListProps['formatOption']> = (
  forActiveFilters: boolean
) => {
  const formatSettlementWallets: NonNullable<
    RefineListProps['formatOption']
  > = (option, formatMessage) => {
    switch (option) {
      case 'eth':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.eth : glossary.eth
        );
      case 'fiat':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
      default:
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
    }
  };
  return formatSettlementWallets;
};

export const RefineSettlementWallets = makeFilter(FILTERS.settlementWallets, {
  searchable: false,
  formatOption: getFormatSettlementWallets(false),
  sortBy: ['name:desc'],
});
